import { useState } from "react";
import { Minus, Plus } from "lucide-react";

const slug = (s) => String(s || "").replace(/\W+/g, "-").toLowerCase();

/** Size groups as tabs, sizes as a tight two-column grid of steppers. */
export default function SizeMatrix({ product, sizes, setSize, theme }) {
    const groups = product.size_groups || [];
    const [group, setGroup] = useState(groups[0]?.name);
    const g = groups.find((x) => x.name === group) || groups[0];
    const total = Object.values(sizes || {}).reduce((n, v) => n + (Number(v) || 0), 0);
    const groupTotal = (gr) => (gr.sizes || []).reduce((n, s) => n + (Number(sizes?.[`${gr.name}|${s.label}`]) || 0), 0);
    const btn = "grid h-6 w-6 place-items-center rounded-full border border-zinc-300 text-zinc-700 transition-colors hover:border-zinc-500";

    return (
        <div className="p-1" data-testid="size-matrix">
            {groups.length > 1 && (
                <div className="flex gap-0.5 rounded-lg bg-zinc-100 p-0.5">
                    {groups.map((gr) => {
                        const on = gr.name === g?.name;
                        const n = groupTotal(gr);
                        return (
                            <button key={gr.name} type="button" onClick={() => setGroup(gr.name)} data-testid={`size-group-${slug(gr.name)}`}
                                className="flex-1 rounded-md px-2 py-1 text-[11px] font-bold uppercase tracking-wide transition-colors"
                                style={on ? { background: theme?.primary, color: theme?.on } : { color: n ? "#18181b" : "#71717a" }}>
                                {gr.name}{n ? ` · ${n}` : ""}
                            </button>
                        );
                    })}
                </div>
            )}
            <div className="mt-2 grid grid-cols-2 gap-1.5">
                {(g?.sizes || []).map((s) => {
                    const key = `${g.name}|${s.label}`;
                    const val = Number(sizes?.[key]) || 0;
                    return (
                        <div key={key} className="flex items-center justify-between rounded-lg border bg-white px-2 py-1.5"
                            style={{ borderColor: val ? theme?.primary : "#e4e4e7" }} data-testid={`size-row-${key}`}>
                            <div className="min-w-0">
                                <p className="text-sm font-bold text-zinc-900">{s.label}</p>
                                {s.upcharge > 0 && <p className="font-mono text-[10px] text-zinc-500">+${s.upcharge.toFixed(2)}</p>}
                            </div>
                            <div className="flex items-center gap-1">
                                <button type="button" className={btn} onClick={() => setSize(key, Math.max(0, val - 1))} data-testid={`size-minus-${key}`}><Minus size={11} /></button>
                                <input type="number" min={0} value={val} onChange={(e) => setSize(key, Math.max(0, Number(e.target.value) || 0))}
                                    className="w-11 rounded-md border border-zinc-200 bg-white px-1 py-0.5 text-center font-mono text-sm text-zinc-900 outline-none"
                                    onFocus={(e) => (e.target.style.borderColor = theme?.primary)} onBlur={(e) => (e.target.style.borderColor = "")}
                                    data-testid={`size-qty-${key}`} />
                                <button type="button" className={btn} onClick={() => setSize(key, val + 1)} data-testid={`size-plus-${key}`}><Plus size={11} /></button>
                            </div>
                        </div>
                    );
                })}
            </div>
            <p className="mt-2 px-1 font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500" data-testid="size-total">Total {total} pcs</p>
        </div>
    );
}
